const DASH = '–';

const money = new Intl.NumberFormat(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const wholeMoney = new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 });
const dateTime = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' });
const date = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' });
const dayUtc = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeZone: 'UTC' });

export function formatMoney(value: number): string {
  return money.format(value);
}

// "€5,610.50", and "-€11,140.00" rather than "€-11,140.00"; "€5,611" without cents.
export function formatEur(value: number, { cents = true }: { cents?: boolean } = {}): string {
  const amount = (cents ? money : wholeMoney).format(Math.abs(value));
  return `${value < 0 ? '-' : ''}€${amount}`;
}

export function formatPercent(rate: number | null | undefined, decimals = 0): string {
  if (rate === null || rate === undefined) return DASH;
  return `${(rate * 100).toFixed(decimals)}%`;
}

export function formatCount(value: number): string {
  return value.toLocaleString();
}

function parse(value: string | null | undefined): Date | null {
  if (!value) return null;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatDateTime(value: string | null | undefined): string {
  const parsed = parse(value);
  return parsed ? dateTime.format(parsed) : DASH;
}

export function formatDate(value: string | null | undefined): string {
  const parsed = parse(value);
  return parsed ? date.format(parsed) : DASH;
}

// Mart days are UTC calendar days ('YYYY-MM-DD'); formatting them in the viewer's zone would shift
// a day for anyone east of Greenwich in the evening.
export function formatDay(ymd: string | null | undefined): string {
  if (!ymd) return DASH;
  const parsed = parse(`${ymd}T00:00:00Z`);
  return parsed ? dayUtc.format(parsed) : DASH;
}

// How long before `today` a UTC day was: "today", "1d ago", "12d ago".
export function formatDaysAgo(ymd: string | null | undefined, today: string): string {
  if (!ymd) return DASH;
  const days = Math.round((Date.parse(`${today}T00:00:00Z`) - Date.parse(`${ymd}T00:00:00Z`)) / 86_400_000);
  if (Number.isNaN(days)) return DASH;
  return days <= 0 ? 'today' : `${days}d ago`;
}

export function todayUtc(now: Date = new Date()): string {
  return now.toISOString().slice(0, 10);
}

export function formatName(profile: { firstName: string | null; lastName: string | null } | null): string {
  if (!profile) return DASH;
  const name = [profile.firstName, profile.lastName].filter(Boolean).join(' ');
  return name || DASH;
}

export const dash = DASH;
